export default "__VITE_ASSET__BuqH3lA1__"